import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../../Components/adminDashboard/Header/Header";
import storeIcon from "../../../assets/images/cat_Icon.png";
import Swal from "sweetalert2";
import combinedServices from "../../../shared/services/user-service";
import html2pdf from "html2pdf.js";

const SalesManagment = () => {
  const navigate = useNavigate();
  const [storeData, setStoreData] = useState([]);
  const [totalstores, setTotalstores] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");

  const totalPages = Math.ceil(totalstores / limit);

  useEffect(() => {
    const fetchStores = async () => {
      try {
        let storeList = await combinedServices.getstore(
          page,
          limit,
          searchQuery
        );
        if (storeList && storeList.data.data.stores) {
          const parsedStores = storeList.data.data.stores.map((store) => ({
            ...store,
            storeimage: store.storeimage ? JSON.parse(store.storeimage) : [],
            district: store.district ? JSON.parse(store.district) : [],
            storeadmins: store.storeadmins ? JSON.parse(store.storeadmins) : [],
          }));

          setStoreData(parsedStores || []);
          setTotalstores(storeList.data.data.total || 0);
        }
      } catch (error) {
        console.error("Error fetching stores:", error);
      }
    };

    fetchStores();
  }, [page, limit, searchQuery]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setPage(1);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  const handleLimitChange = (e) => {
    setLimit(Number(e.target.value));
    setPage(1);
  };
  const formatDistricts = (districts) => {
    if (!districts || !Array.isArray(districts)) return "";
    return districts.map((d) => `D${d}`).join(", ");
  };

  const formatAdminNames = (admins) => {
    if (!admins || !Array.isArray(admins)) return "";
    return admins
      .map((admin) => `${admin.firstname} ${admin.lastname}`)
      .join(", ");
  };

  return (
    <>
      <Header />
      <div className="dbAdminRight newDbRight">
        <div className="dbMid dbInner">
          <div className="dbMainHd">Sales Managment</div>
          <div className="catFilterWrp">
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="catFilterCont">
                <div className="filWrp">
                  <label className="label2">Showing</label>
                  <select
                    value={limit}
                    onChange={handleLimitChange}
                    className="form_ctrl ctrlDrop"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                  </select>
                  <span className="ent">entries</span>
                  <div className="srchGrp">
                    <input
                      type="text"
                      value={searchQuery}
                      onChange={handleSearchChange}
                      className="form_ctrl ctrlSrch"
                      placeholder="Search with Store Name"
                    />
                  </div>
                  <div>
                    <button
                      style={{ marginLeft: 450 }}
                      className="date-button"
                      // onClick={() => addDates(null, null, null, null, false)}
                      // onClick={() => getaccesstoke()}
                    >
                      Download All Report
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="listTablWrp">
            <div className="tblWrp">
              <table>
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Store Name</th>
                    <th>District</th>
                    <th>Admins</th>
                    <th>Created On</th>
                    <th>Updated On</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {storeData.length > 0 ? (
                    storeData.map((store, index) => (
                      <tr key={store.store_id}>
                        <td>{(page - 1) * limit + index + 1}</td>
                        <td>
                          <div className="catPara">
                            <img
                              src={
                                store.storeimage.length > 0
                                  ? store.storeimage[0]
                                  : storeIcon
                              }
                              alt="storeIcon"
                            />
                            {store.storename}
                          </div>
                        </td>
                        <td>{formatDistricts(store.district)}</td>
                        <td>{formatAdminNames(store.storeadmins)}</td>
                        <td>
                          {new Date(store.createdOn).toLocaleDateString()}
                        </td>
                        <td>
                          {new Date(store.updatedOn).toLocaleDateString()}
                        </td>
                        <td>
                          <div className="tblBtnWrp" style={{ display: "flex", gap: "8px", width: "auto" }}>
                            {/* <button 
                              onClick={() => navigate(`/admin/sales-report/${store.id}`, { state: { storeName: store.storename } })}
                              className="btn btn-primary"
                              style={{ padding: "8px 16px", fontSize: "14px", fontWeight: "500" }}
                            >
                              Sale Reports
                            </button> */}
                            <button 
                              onClick={() => navigate(`/paypalManagment/${store.id}`, { state: { storeName: store.storename } })}
                              className="btn btn-info"
                              style={{ padding: "8px 16px", fontSize: "14px", fontWeight: "500", backgroundColor: "#0070ba", color: "white", border: "none", borderRadius: "4px" }}
                            >
                              PayPal Reports
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6">No stores available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* Pagination */}
            <div className="tblPagiWrp">
              <ul className="pagination namPagi">
                <li>
                  <button
                    onClick={() => handlePageChange(page - 1)}
                    disabled={page === 1}
                  >
                    Prev
                  </button>
                </li>
                {Array.from({ length: totalPages }, (_, index) => (
                  <li key={index}>
                    <button
                      className={page === index + 1 ? "active" : ""}
                      onClick={() => handlePageChange(index + 1)}
                    >
                      {index + 1}
                    </button>
                  </li>
                ))}
                <li>
                  <button
                    onClick={() => handlePageChange(page + 1)}
                    disabled={page === totalPages}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SalesManagment;
